// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Common = require("../utils/Common.bs.js");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var MM_parser = require("../mm-utils/MM_parser.bs.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_SetInt = require("rescript/lib/js/belt_SetInt.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var UseLongClick = require("../ui-utils/UseLongClick.bs.js");
var MM_wrk_client = require("../worker/MM_wrk_client.bs.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.bs.js");
var MM_react_common = require("../ui-utils/MM_react_common.bs.js");
var Expln_React_Modal = require("../../rescript-utils/main/react-components/Expln_React_Modal.bs.js");
var MM_wrk_FindParens = require("../worker/MM_wrk_FindParens.bs.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.bs.js");
var Expln_utils_common = require("../../rescript-utils/main/Expln_utils_common.bs.js");
var JsxPPXReactSupport = require("rescript/lib/js/jsxPPXReactSupport.js");
var Paper = require("@mui/material/Paper").default;
var Expln_utils_promise = require("../../rescript-utils/main/Expln_utils_promise.bs.js");
var Button = require("@mui/material/Button").default;
var MM_cmp_asrts_to_skip = require("./MM_cmp_asrts_to_skip.bs.js");
var MM_cmp_type_settings = require("./MM_cmp_type_settings.bs.js");
var Divider = require("@mui/material/Divider").default;
var Expln_utils_jsonParse = require("../../rescript-utils/main/Expln_utils_jsonParse.bs.js");
var Checkbox = require("@mui/material/Checkbox").default;
var TextField = require("@mui/material/TextField").default;
var MM_cmp_web_src_settings = require("./MM_cmp_web_src_settings.bs.js");
var Sync = require("@mui/icons-material/Sync").default;
var IconButton = require("@mui/material/IconButton").default;
var MM_cmp_edit_stmts_setting = require("./MM_cmp_edit_stmts_setting.bs.js");
var FormControlLabel = require("@mui/material/FormControlLabel").default;

var allColors = [
  "#e6194B",
  "#3cb44b",
  "#ffe119",
  "#4363d8",
  "#f58231",
  "#911eb4",
  "#42d4f4",
  "#f032e6",
  "#bfef45",
  "#fabed4",
  "#469990",
  "#dcbeff",
  "#9A6324",
  "#fffac8",
  "#800000",
  "#aaffc3",
  "#808000",
  "#ffd8b1",
  "#000075",
  "#a9a9a9",
  "#000000"
];

var longClickDelayMsMin = (UseLongClick.repeatDelayMs | 0) + 100 | 0;

var setmm = {
  id: "0",
  alias: "set.mm:latest",
  url: "https://us.metamath.org/metamath/set.mm",
  trusted: false,
  err: undefined
};

var isetmm = {
  id: "0",
  alias: "iset.mm:latest",
  url: "https://us.metamath.org/metamath/iset.mm",
  trusted: false,
  err: undefined
};

var defaultAliases = [
  "set.mm:latest",
  "iset.mm:latest"
];

function createDefaultSettings(param) {
  return {
          parens: "( ) [ ] { } [. ]. [_ ]_ <. >. <\" \"> << >> [s ]s (. ). (( )) [b /b",
          parensErr: undefined,
          asrtsToSkip: [],
          asrtsToSkipRegex: "New usage of \"([^\"]+)\" is discouraged",
          editStmtsByLeftClick: false,
          initStmtIsGoal: true,
          defaultStmtLabel: "qed",
          defaultStmtType: "|-",
          checkSyntax: true,
          stickGoalToBottom: true,
          typeNextId: 4,
          typeSettings: [
            {
              id: "0",
              typ: "wff",
              color: "#4363d8",
              prefix: "&W",
              err: undefined
            },
            {
              id: "1",
              typ: "term",
              color: "#000000",
              prefix: "&T",
              err: undefined
            },
            {
              id: "2",
              typ: "setvar",
              color: "#e6194B",
              prefix: "&S",
              err: undefined
            },
            {
              id: "3",
              typ: "class",
              color: "#f032e6",
              prefix: "&C",
              err: undefined
            }
          ],
          webSrcNextId: 1,
          webSrcSettings: [
            setmm,
            isetmm
          ],
          longClickEnabled: true,
          longClickDelayMsStr: String(500),
          hideContextSelector: false,
          showVisByDefault: false,
          editorHistMaxLengthStr: String(20)
        };
}

function addWebSrcSetting(st) {
  var newId = String(st.webSrcNextId);
  return {
          parens: st.parens,
          parensErr: st.parensErr,
          asrtsToSkip: st.asrtsToSkip,
          asrtsToSkipRegex: st.asrtsToSkipRegex,
          editStmtsByLeftClick: st.editStmtsByLeftClick,
          initStmtIsGoal: st.initStmtIsGoal,
          defaultStmtLabel: st.defaultStmtLabel,
          defaultStmtType: st.defaultStmtType,
          checkSyntax: st.checkSyntax,
          stickGoalToBottom: st.stickGoalToBottom,
          typeNextId: st.typeNextId,
          typeSettings: st.typeSettings,
          webSrcNextId: st.webSrcNextId + 1 | 0,
          webSrcSettings: st.webSrcSettings.concat([{
                  id: newId,
                  alias: "",
                  url: "",
                  trusted: false,
                  err: undefined
                }]),
          longClickEnabled: st.longClickEnabled,
          longClickDelayMsStr: st.longClickDelayMsStr,
          hideContextSelector: st.hideContextSelector,
          showVisByDefault: st.showVisByDefault,
          editorHistMaxLengthStr: st.editorHistMaxLengthStr
        };
}

function validateAndCorrectParens(st) {
  var newParens = st.parens.trim();
  var parensErr = Common.getSpaceSeparatedValuesAsArray(newParens).length % 2 === 0 ? undefined : "Number of parentheses must be even.";
  return {
          parens: newParens,
          parensErr: parensErr,
          asrtsToSkip: st.asrtsToSkip,
          asrtsToSkipRegex: st.asrtsToSkipRegex,
          editStmtsByLeftClick: st.editStmtsByLeftClick,
          initStmtIsGoal: st.initStmtIsGoal,
          defaultStmtLabel: st.defaultStmtLabel,
          defaultStmtType: st.defaultStmtType,
          checkSyntax: st.checkSyntax,
          stickGoalToBottom: st.stickGoalToBottom,
          typeNextId: st.typeNextId,
          typeSettings: st.typeSettings,
          webSrcNextId: st.webSrcNextId,
          webSrcSettings: st.webSrcSettings,
          longClickEnabled: st.longClickEnabled,
          longClickDelayMsStr: st.longClickDelayMsStr,
          hideContextSelector: st.hideContextSelector,
          showVisByDefault: st.showVisByDefault,
          editorHistMaxLengthStr: st.editorHistMaxLengthStr
        };
}

function validateDefaultStmtLabel(label) {
  return label.replace(/[^A-Za-z0-9._-]/g, "");
}

function validateAndCorrectDefaultStmtType(st) {
  return {
          parens: st.parens,
          parensErr: st.parensErr,
          asrtsToSkip: st.asrtsToSkip,
          asrtsToSkipRegex: st.asrtsToSkipRegex,
          editStmtsByLeftClick: st.editStmtsByLeftClick,
          initStmtIsGoal: st.initStmtIsGoal,
          defaultStmtLabel: st.defaultStmtLabel,
          defaultStmtType: st.defaultStmtType.trim(),
          checkSyntax: st.checkSyntax,
          stickGoalToBottom: st.stickGoalToBottom,
          typeNextId: st.typeNextId,
          typeSettings: st.typeSettings,
          webSrcNextId: st.webSrcNextId,
          webSrcSettings: st.webSrcSettings,
          longClickEnabled: st.longClickEnabled,
          longClickDelayMsStr: st.longClickDelayMsStr,
          hideContextSelector: st.hideContextSelector,
          showVisByDefault: st.showVisByDefault,
          editorHistMaxLengthStr: st.editorHistMaxLengthStr
        };
}

function validateAndCorrectDefaultStmtLabel(st) {
  return {
          parens: st.parens,
          parensErr: st.parensErr,
          asrtsToSkip: st.asrtsToSkip,
          asrtsToSkipRegex: st.asrtsToSkipRegex,
          editStmtsByLeftClick: st.editStmtsByLeftClick,
          initStmtIsGoal: st.initStmtIsGoal,
          defaultStmtLabel: validateDefaultStmtLabel(st.defaultStmtLabel),
          defaultStmtType: st.defaultStmtType,
          checkSyntax: st.checkSyntax,
          stickGoalToBottom: st.stickGoalToBottom,
          typeNextId: st.typeNextId,
          typeSettings: st.typeSettings,
          webSrcNextId: st.webSrcNextId,
          webSrcSettings: st.webSrcSettings,
          longClickEnabled: st.longClickEnabled,
          longClickDelayMsStr: st.longClickDelayMsStr,
          hideContextSelector: st.hideContextSelector,
          showVisByDefault: st.showVisByDefault,
          editorHistMaxLengthStr: st.editorHistMaxLengthStr
        };
}

function validateAndCorrectTypeSettings(st) {
  var strContainsWhitespaceRegex = /\s+/;
  var validateAndCorrectTypeSetting = function (ts) {
    var newId = String(Belt_Option.getWithDefault(Belt_Int.fromString(ts.id), 0));
    var newTyp = ts.typ.trim();
    var typHasWhitespace = Belt_Option.isSome(Caml_option.null_to_opt(newTyp.match(strContainsWhitespaceRegex)));
    var typIsEmpty = newTyp.length === 0;
    var newColor = allColors.includes(ts.color) ? ts.color : Caml_array.get(allColors, 0);
    var newPrefix = ts.prefix.trim();
    var prefixHasWhitespace = Belt_Option.isSome(Caml_option.null_to_opt(newPrefix.match(strContainsWhitespaceRegex)));
    var prefixIsEmpty = newPrefix.length === 0;
    var err = typHasWhitespace ? "Type should not contain whitespaces." : (
        typIsEmpty ? "Type should not be empty." : (
            prefixHasWhitespace ? "Work variable prefix should not contain whitespaces." : (
                prefixIsEmpty ? "Work variable prefix should not be empty." : undefined
              )
          )
      );
    return {
            id: newId,
            typ: newTyp,
            color: newColor,
            prefix: newPrefix,
            err: err
          };
  };
  var validatedTypeSettings = st.typeSettings.map(validateAndCorrectTypeSetting);
  var distinctTypeIds = Belt_SetInt.fromArray(validatedTypeSettings.map(function (ts) {
            return Belt_Option.getExn(Belt_Int.fromString(ts.id));
          }));
  var validatedTypeSettings$1;
  if (Belt_SetInt.size(distinctTypeIds) === validatedTypeSettings.length) {
    validatedTypeSettings$1 = validatedTypeSettings;
  } else {
    var maxId = Belt_Option.getWithDefault(Belt_SetInt.maximum(distinctTypeIds), 0);
    validatedTypeSettings$1 = validatedTypeSettings.map(function (ts, i) {
          return {
                  id: String((maxId + i | 0) + 1 | 0),
                  typ: ts.typ,
                  color: ts.color,
                  prefix: ts.prefix,
                  err: ts.err
                };
        });
  }
  var maxTypSettId = validatedTypeSettings$1.reduce((function (maxId, ts) {
          var id = Belt_Option.getExn(Belt_Int.fromString(ts.id));
          if (id <= maxId) {
            return maxId;
          } else {
            return id;
          }
        }), 0);
  var newNextId = maxTypSettId < st.typeNextId ? st.typeNextId : maxTypSettId + 1 | 0;
  return {
          parens: st.parens,
          parensErr: st.parensErr,
          asrtsToSkip: st.asrtsToSkip,
          asrtsToSkipRegex: st.asrtsToSkipRegex,
          editStmtsByLeftClick: st.editStmtsByLeftClick,
          initStmtIsGoal: st.initStmtIsGoal,
          defaultStmtLabel: st.defaultStmtLabel,
          defaultStmtType: st.defaultStmtType,
          checkSyntax: st.checkSyntax,
          stickGoalToBottom: st.stickGoalToBottom,
          typeNextId: newNextId,
          typeSettings: validatedTypeSettings$1,
          webSrcNextId: st.webSrcNextId,
          webSrcSettings: st.webSrcSettings,
          longClickEnabled: st.longClickEnabled,
          longClickDelayMsStr: st.longClickDelayMsStr,
          hideContextSelector: st.hideContextSelector,
          showVisByDefault: st.showVisByDefault,
          editorHistMaxLengthStr: st.editorHistMaxLengthStr
        };
}

function validateAndCorrectWebSrcSettings(st) {
  var validateAndCorrectWebSrcSetting = function (src) {
    var newId = String(Belt_Option.getWithDefault(Belt_Int.fromString(src.id), 0));
    var newAlias = src.alias.trim();
    var newUrl = src.url.trim();
    var err = newUrl.length === 0 ? "URL should not be empty." : undefined;
    return {
            id: newId,
            alias: newAlias,
            url: newUrl,
            trusted: src.trusted,
            err: err
          };
  };
  var validatedWebSrcSettings = st.webSrcSettings.map(validateAndCorrectWebSrcSetting);
  var distinctIds = Belt_SetInt.fromArray(validatedWebSrcSettings.map(function (src) {
            return Belt_Option.getExn(Belt_Int.fromString(src.id));
          }));
  var validatedWebSrcSettings$1;
  if (Belt_SetInt.size(distinctIds) === validatedWebSrcSettings.length) {
    validatedWebSrcSettings$1 = validatedWebSrcSettings;
  } else {
    var maxId = Belt_Option.getWithDefault(Belt_SetInt.maximum(distinctIds), 0);
    validatedWebSrcSettings$1 = validatedWebSrcSettings.map(function (src, i) {
          return {
                  id: String((maxId + i | 0) + 1 | 0),
                  alias: src.alias,
                  url: src.url,
                  trusted: src.trusted,
                  err: src.err
                };
        });
  }
  var maxId$1 = validatedWebSrcSettings$1.reduce((function (maxId, src) {
          var id = Belt_Option.getExn(Belt_Int.fromString(src.id));
          if (id <= maxId) {
            return maxId;
          } else {
            return id;
          }
        }), 0);
  var newNextId = maxId$1 < st.webSrcNextId ? st.webSrcNextId : maxId$1 + 1 | 0;
  var state = {
    parens: st.parens,
    parensErr: st.parensErr,
    asrtsToSkip: st.asrtsToSkip,
    asrtsToSkipRegex: st.asrtsToSkipRegex,
    editStmtsByLeftClick: st.editStmtsByLeftClick,
    initStmtIsGoal: st.initStmtIsGoal,
    defaultStmtLabel: st.defaultStmtLabel,
    defaultStmtType: st.defaultStmtType,
    checkSyntax: st.checkSyntax,
    stickGoalToBottom: st.stickGoalToBottom,
    typeNextId: st.typeNextId,
    typeSettings: st.typeSettings,
    webSrcNextId: newNextId,
    webSrcSettings: validatedWebSrcSettings$1,
    longClickEnabled: st.longClickEnabled,
    longClickDelayMsStr: st.longClickDelayMsStr,
    hideContextSelector: st.hideContextSelector,
    showVisByDefault: st.showVisByDefault,
    editorHistMaxLengthStr: st.editorHistMaxLengthStr
  };
  var defaultSettings = createDefaultSettings(undefined);
  return defaultSettings.webSrcSettings.reduce((function (state, $$default) {
                var alias = $$default.alias;
                var url = $$default.url;
                var state$1;
                if (Belt_Option.isSome(Caml_option.undefined_to_opt(state.webSrcSettings.find(function (ws) {
                                return ws.alias === alias;
                              })))) {
                  state$1 = state;
                } else {
                  var newId = String(state.webSrcNextId);
                  var state$2 = addWebSrcSetting(state);
                  state$1 = {
                    parens: state$2.parens,
                    parensErr: state$2.parensErr,
                    asrtsToSkip: state$2.asrtsToSkip,
                    asrtsToSkipRegex: state$2.asrtsToSkipRegex,
                    editStmtsByLeftClick: state$2.editStmtsByLeftClick,
                    initStmtIsGoal: state$2.initStmtIsGoal,
                    defaultStmtLabel: state$2.defaultStmtLabel,
                    defaultStmtType: state$2.defaultStmtType,
                    checkSyntax: state$2.checkSyntax,
                    stickGoalToBottom: state$2.stickGoalToBottom,
                    typeNextId: state$2.typeNextId,
                    typeSettings: state$2.typeSettings,
                    webSrcNextId: state$2.webSrcNextId,
                    webSrcSettings: state$2.webSrcSettings.map(function (ws) {
                          if (ws.id === newId) {
                            return {
                                    id: ws.id,
                                    alias: alias,
                                    url: ws.url,
                                    trusted: ws.trusted,
                                    err: ws.err
                                  };
                          } else {
                            return ws;
                          }
                        }),
                    longClickEnabled: state$2.longClickEnabled,
                    longClickDelayMsStr: state$2.longClickDelayMsStr,
                    hideContextSelector: state$2.hideContextSelector,
                    showVisByDefault: state$2.showVisByDefault,
                    editorHistMaxLengthStr: state$2.editorHistMaxLengthStr
                  };
                }
                var state_parens = state$1.parens;
                var state_parensErr = state$1.parensErr;
                var state_asrtsToSkip = state$1.asrtsToSkip;
                var state_asrtsToSkipRegex = state$1.asrtsToSkipRegex;
                var state_editStmtsByLeftClick = state$1.editStmtsByLeftClick;
                var state_initStmtIsGoal = state$1.initStmtIsGoal;
                var state_defaultStmtLabel = state$1.defaultStmtLabel;
                var state_defaultStmtType = state$1.defaultStmtType;
                var state_checkSyntax = state$1.checkSyntax;
                var state_stickGoalToBottom = state$1.stickGoalToBottom;
                var state_typeNextId = state$1.typeNextId;
                var state_typeSettings = state$1.typeSettings;
                var state_webSrcNextId = state$1.webSrcNextId;
                var state_webSrcSettings = state$1.webSrcSettings.map(function (ws) {
                      if (ws.alias === alias) {
                        return {
                                id: ws.id,
                                alias: ws.alias,
                                url: url,
                                trusted: ws.trusted,
                                err: ws.err
                              };
                      } else {
                        return ws;
                      }
                    });
                var state_longClickEnabled = state$1.longClickEnabled;
                var state_longClickDelayMsStr = state$1.longClickDelayMsStr;
                var state_hideContextSelector = state$1.hideContextSelector;
                var state_showVisByDefault = state$1.showVisByDefault;
                var state_editorHistMaxLengthStr = state$1.editorHistMaxLengthStr;
                return {
                        parens: state_parens,
                        parensErr: state_parensErr,
                        asrtsToSkip: state_asrtsToSkip,
                        asrtsToSkipRegex: state_asrtsToSkipRegex,
                        editStmtsByLeftClick: state_editStmtsByLeftClick,
                        initStmtIsGoal: state_initStmtIsGoal,
                        defaultStmtLabel: state_defaultStmtLabel,
                        defaultStmtType: state_defaultStmtType,
                        checkSyntax: state_checkSyntax,
                        stickGoalToBottom: state_stickGoalToBottom,
                        typeNextId: state_typeNextId,
                        typeSettings: state_typeSettings,
                        webSrcNextId: state_webSrcNextId,
                        webSrcSettings: state_webSrcSettings.sort(function (s1, s2) {
                              var i1 = defaultAliases.includes(s1.alias) ? 0 : 1;
                              var i2 = defaultAliases.includes(s2.alias) ? 0 : 1;
                              return i1 - i2 | 0;
                            }),
                        longClickEnabled: state_longClickEnabled,
                        longClickDelayMsStr: state_longClickDelayMsStr,
                        hideContextSelector: state_hideContextSelector,
                        showVisByDefault: state_showVisByDefault,
                        editorHistMaxLengthStr: state_editorHistMaxLengthStr
                      };
              }), state);
}

function validateLongClickDelayMs(ms) {
  if (ms < longClickDelayMsMin) {
    return {
            TAG: /* Ok */0,
            _0: longClickDelayMsMin
          };
  } else if (3000 < ms) {
    return {
            TAG: /* Ok */0,
            _0: 3000
          };
  } else {
    return {
            TAG: /* Ok */0,
            _0: ms
          };
  }
}

function validateAndCorrectLongClickSettings(st) {
  var ms = Belt_Int.fromString(st.longClickDelayMsStr);
  var tmp;
  if (ms !== undefined) {
    var ms$1 = validateLongClickDelayMs(ms);
    tmp = ms$1.TAG === /* Ok */0 ? String(ms$1._0) : String(500);
  } else {
    tmp = String(500);
  }
  return {
          parens: st.parens,
          parensErr: st.parensErr,
          asrtsToSkip: st.asrtsToSkip,
          asrtsToSkipRegex: st.asrtsToSkipRegex,
          editStmtsByLeftClick: st.editStmtsByLeftClick,
          initStmtIsGoal: st.initStmtIsGoal,
          defaultStmtLabel: st.defaultStmtLabel,
          defaultStmtType: st.defaultStmtType,
          checkSyntax: st.checkSyntax,
          stickGoalToBottom: st.stickGoalToBottom,
          typeNextId: st.typeNextId,
          typeSettings: st.typeSettings,
          webSrcNextId: st.webSrcNextId,
          webSrcSettings: st.webSrcSettings,
          longClickEnabled: st.longClickEnabled,
          longClickDelayMsStr: tmp,
          hideContextSelector: st.hideContextSelector,
          showVisByDefault: st.showVisByDefault,
          editorHistMaxLengthStr: st.editorHistMaxLengthStr
        };
}

function validateEditorHistoryMaxLength(length) {
  if (length < 0) {
    return {
            TAG: /* Ok */0,
            _0: 0
          };
  } else if (1000 < length) {
    return {
            TAG: /* Ok */0,
            _0: 1000
          };
  } else {
    return {
            TAG: /* Ok */0,
            _0: length
          };
  }
}

function validateAndCorrectState(st) {
  var st$1 = validateAndCorrectParens(st);
  var st$2 = validateAndCorrectDefaultStmtType(st$1);
  var st$3 = validateAndCorrectTypeSettings(st$2);
  var st$4 = validateAndCorrectWebSrcSettings(st$3);
  var st$5 = validateAndCorrectLongClickSettings(st$4);
  var st$6 = validateAndCorrectDefaultStmtLabel(st$5);
  var length = Belt_Int.fromString(st$6.editorHistMaxLengthStr);
  var tmp;
  if (length !== undefined) {
    var length$1 = validateEditorHistoryMaxLength(length);
    tmp = length$1.TAG === /* Ok */0 ? String(length$1._0) : String(20);
  } else {
    tmp = String(20);
  }
  return {
          parens: st$6.parens,
          parensErr: st$6.parensErr,
          asrtsToSkip: st$6.asrtsToSkip,
          asrtsToSkipRegex: st$6.asrtsToSkipRegex,
          editStmtsByLeftClick: st$6.editStmtsByLeftClick,
          initStmtIsGoal: st$6.initStmtIsGoal,
          defaultStmtLabel: st$6.defaultStmtLabel,
          defaultStmtType: st$6.defaultStmtType,
          checkSyntax: st$6.checkSyntax,
          stickGoalToBottom: st$6.stickGoalToBottom,
          typeNextId: st$6.typeNextId,
          typeSettings: st$6.typeSettings,
          webSrcNextId: st$6.webSrcNextId,
          webSrcSettings: st$6.webSrcSettings,
          longClickEnabled: st$6.longClickEnabled,
          longClickDelayMsStr: st$6.longClickDelayMsStr,
          hideContextSelector: st$6.hideContextSelector,
          showVisByDefault: st$6.showVisByDefault,
          editorHistMaxLengthStr: tmp
        };
}

function stateToSettings(st) {
  return {
          parens: st.parens,
          asrtsToSkip: st.asrtsToSkip,
          asrtsToSkipRegex: st.asrtsToSkipRegex,
          editStmtsByLeftClick: st.editStmtsByLeftClick,
          defaultStmtType: st.defaultStmtType,
          defaultStmtLabel: st.defaultStmtLabel,
          initStmtIsGoal: st.initStmtIsGoal,
          checkSyntax: st.checkSyntax,
          stickGoalToBottom: st.stickGoalToBottom,
          typeSettings: st.typeSettings.map(function (typSett) {
                return {
                        typ: typSett.typ,
                        color: typSett.color,
                        prefix: typSett.prefix
                      };
              }),
          webSrcSettings: st.webSrcSettings.map(function (s) {
                return {
                        alias: s.alias,
                        url: s.url,
                        trusted: s.trusted
                      };
              }),
          longClickEnabled: st.longClickEnabled,
          longClickDelayMs: Belt_Option.getWithDefault(Belt_Int.fromString(st.longClickDelayMsStr), 500),
          hideContextSelector: st.hideContextSelector,
          showVisByDefault: st.showVisByDefault,
          editorHistMaxLength: Belt_Option.getWithDefault(Belt_Int.fromString(st.editorHistMaxLengthStr), 20)
        };
}

function settingsToState(ls) {
  return validateAndCorrectState({
              parens: ls.parens,
              parensErr: undefined,
              asrtsToSkip: ls.asrtsToSkip,
              asrtsToSkipRegex: ls.asrtsToSkipRegex,
              editStmtsByLeftClick: ls.editStmtsByLeftClick,
              initStmtIsGoal: ls.initStmtIsGoal,
              defaultStmtLabel: ls.defaultStmtLabel,
              defaultStmtType: ls.defaultStmtType,
              checkSyntax: ls.checkSyntax,
              stickGoalToBottom: ls.stickGoalToBottom,
              typeNextId: 0,
              typeSettings: ls.typeSettings.map(function (lts) {
                    return {
                            id: "0",
                            typ: lts.typ,
                            color: lts.color,
                            prefix: lts.prefix,
                            err: undefined
                          };
                  }),
              webSrcNextId: 0,
              webSrcSettings: ls.webSrcSettings.map(function (s) {
                    return {
                            id: "0",
                            alias: s.alias,
                            url: s.url,
                            trusted: s.trusted,
                            err: undefined
                          };
                  }),
              longClickEnabled: ls.longClickEnabled,
              longClickDelayMsStr: String(ls.longClickDelayMs),
              hideContextSelector: ls.hideContextSelector,
              showVisByDefault: ls.showVisByDefault,
              editorHistMaxLengthStr: String(ls.editorHistMaxLength)
            });
}

var settingsLocStorKey = "settings";

function settingsSaveToLocStor(settings) {
  localStorage.setItem(settingsLocStorKey, Expln_utils_common.stringify(settings));
}

function readStateFromLocStor(param) {
  var defaultSettings = createDefaultSettings(undefined);
  var settingsLocStorStr = localStorage.getItem(settingsLocStorKey);
  if (settingsLocStorStr === null) {
    return defaultSettings;
  }
  var parseResult = Expln_utils_jsonParse.parseJson(settingsLocStorStr, (function (__x) {
          return Expln_utils_jsonParse.asObj(__x, (function (d) {
                        return {
                                parens: Expln_utils_jsonParse.str(d, "parens", undefined, (function (param) {
                                        return defaultSettings.parens;
                                      }), undefined),
                                parensErr: undefined,
                                asrtsToSkip: Expln_utils_jsonParse.arr(d, "asrtsToSkip", (function (__x) {
                                        return Expln_utils_jsonParse.asStr(__x, undefined, undefined, undefined);
                                      }), undefined, (function (param) {
                                        return defaultSettings.asrtsToSkip;
                                      }), undefined),
                                asrtsToSkipRegex: Expln_utils_jsonParse.str(d, "asrtsToSkipRegex", undefined, (function (param) {
                                        return defaultSettings.asrtsToSkipRegex;
                                      }), undefined),
                                editStmtsByLeftClick: Expln_utils_jsonParse.bool(d, "editStmtsByLeftClick", undefined, (function (param) {
                                        return defaultSettings.editStmtsByLeftClick;
                                      }), undefined),
                                initStmtIsGoal: Expln_utils_jsonParse.bool(d, "initStmtIsGoal", undefined, (function (param) {
                                        return defaultSettings.initStmtIsGoal;
                                      }), undefined),
                                defaultStmtLabel: Expln_utils_jsonParse.str(d, "defaultStmtLabel", (function (str) {
                                        return {
                                                TAG: /* Ok */0,
                                                _0: validateDefaultStmtLabel(str)
                                              };
                                      }), (function (param) {
                                        return defaultSettings.defaultStmtLabel;
                                      }), undefined),
                                defaultStmtType: Expln_utils_jsonParse.str(d, "defaultStmtType", undefined, (function (param) {
                                        return defaultSettings.defaultStmtType;
                                      }), undefined),
                                checkSyntax: Expln_utils_jsonParse.bool(d, "checkSyntax", undefined, (function (param) {
                                        return defaultSettings.checkSyntax;
                                      }), undefined),
                                stickGoalToBottom: Expln_utils_jsonParse.bool(d, "stickGoalToBottom", undefined, (function (param) {
                                        return defaultSettings.stickGoalToBottom;
                                      }), undefined),
                                typeNextId: 0,
                                typeSettings: Expln_utils_jsonParse.arr(d, "typeSettings", (function (__x) {
                                        return Expln_utils_jsonParse.asObj(__x, (function (d) {
                                                      return {
                                                              id: "0",
                                                              typ: Expln_utils_jsonParse.str(d, "typ", undefined, undefined, undefined),
                                                              color: Expln_utils_jsonParse.str(d, "color", undefined, undefined, undefined),
                                                              prefix: Expln_utils_jsonParse.str(d, "prefix", undefined, undefined, undefined),
                                                              err: undefined
                                                            };
                                                    }), undefined, undefined, undefined);
                                      }), undefined, (function (param) {
                                        return defaultSettings.typeSettings;
                                      }), undefined),
                                webSrcNextId: 0,
                                webSrcSettings: Expln_utils_jsonParse.arr(d, "webSrcSettings", (function (__x) {
                                        return Expln_utils_jsonParse.asObj(__x, (function (d) {
                                                      return {
                                                              id: "0",
                                                              alias: Expln_utils_jsonParse.str(d, "alias", undefined, undefined, undefined),
                                                              url: Expln_utils_jsonParse.str(d, "url", undefined, undefined, undefined),
                                                              trusted: Expln_utils_jsonParse.bool(d, "trusted", undefined, undefined, undefined),
                                                              err: undefined
                                                            };
                                                    }), undefined, undefined, undefined);
                                      }), undefined, (function (param) {
                                        return defaultSettings.webSrcSettings;
                                      }), undefined),
                                longClickEnabled: Expln_utils_jsonParse.bool(d, "longClickEnabled", undefined, (function (param) {
                                        return defaultSettings.longClickEnabled;
                                      }), undefined),
                                longClickDelayMsStr: String(Expln_utils_jsonParse.$$int(d, "longClickDelayMs", validateLongClickDelayMs, (function (param) {
                                            return 500;
                                          }), undefined)),
                                hideContextSelector: Expln_utils_jsonParse.bool(d, "hideContextSelector", undefined, (function (param) {
                                        return defaultSettings.hideContextSelector;
                                      }), undefined),
                                showVisByDefault: Expln_utils_jsonParse.bool(d, "showVisByDefault", undefined, (function (param) {
                                        return defaultSettings.showVisByDefault;
                                      }), undefined),
                                editorHistMaxLengthStr: String(Expln_utils_jsonParse.$$int(d, "editorHistMaxLength", validateEditorHistoryMaxLength, (function (param) {
                                            return 20;
                                          }), undefined))
                              };
                      }), undefined, undefined, undefined);
        }), undefined, (function (param) {
          return defaultSettings;
        }), undefined);
  if (parseResult.TAG === /* Ok */0) {
    return validateAndCorrectState(parseResult._0);
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Cannot read settings from the local storage: " + parseResult._0 + ""
        },
        Error: new Error()
      };
}

function settingsReadFromLocStor(param) {
  return stateToSettings(readStateFromLocStor(undefined));
}

function isValid(st) {
  if (Belt_Option.isNone(st.parensErr) && st.typeSettings.every(function (ts) {
          return Belt_Option.isNone(ts.err);
        })) {
    return st.webSrcSettings.every(function (s) {
                return Belt_Option.isNone(s.err);
              });
  } else {
    return false;
  }
}

function eqState(st1, st2) {
  if (st1.parens === st2.parens && Caml_obj.equal(st1.asrtsToSkip, st2.asrtsToSkip) && st1.asrtsToSkipRegex === st2.asrtsToSkipRegex && st1.editStmtsByLeftClick === st2.editStmtsByLeftClick && st1.initStmtIsGoal === st2.initStmtIsGoal && st1.defaultStmtLabel === st2.defaultStmtLabel && st1.defaultStmtType === st2.defaultStmtType && st1.checkSyntax === st2.checkSyntax && st1.stickGoalToBottom === st2.stickGoalToBottom && st1.typeSettings.length === st2.typeSettings.length && st1.typeSettings.every(function (ts1, i) {
          var ts2 = Caml_array.get(st2.typeSettings, i);
          if (ts1.typ === ts2.typ && ts1.color === ts2.color) {
            return ts1.prefix === ts2.prefix;
          } else {
            return false;
          }
        }) && st1.webSrcSettings.length === st2.webSrcSettings.length && st1.webSrcSettings.every(function (ts1, i) {
          var ts2 = Caml_array.get(st2.webSrcSettings, i);
          if (ts1.alias === ts2.alias && ts1.url === ts2.url) {
            return ts1.trusted === ts2.trusted;
          } else {
            return false;
          }
        }) && st1.longClickEnabled === st2.longClickEnabled && st1.longClickDelayMsStr === st2.longClickDelayMsStr && st1.hideContextSelector === st2.hideContextSelector && st1.showVisByDefault === st2.showVisByDefault) {
    return st1.editorHistMaxLengthStr === st2.editorHistMaxLengthStr;
  } else {
    return false;
  }
}

function updateParens(st, parens) {
  return {
          parens: parens,
          parensErr: undefined,
          asrtsToSkip: st.asrtsToSkip,
          asrtsToSkipRegex: st.asrtsToSkipRegex,
          editStmtsByLeftClick: st.editStmtsByLeftClick,
          initStmtIsGoal: st.initStmtIsGoal,
          defaultStmtLabel: st.defaultStmtLabel,
          defaultStmtType: st.defaultStmtType,
          checkSyntax: st.checkSyntax,
          stickGoalToBottom: st.stickGoalToBottom,
          typeNextId: st.typeNextId,
          typeSettings: st.typeSettings,
          webSrcNextId: st.webSrcNextId,
          webSrcSettings: st.webSrcSettings,
          longClickEnabled: st.longClickEnabled,
          longClickDelayMsStr: st.longClickDelayMsStr,
          hideContextSelector: st.hideContextSelector,
          showVisByDefault: st.showVisByDefault,
          editorHistMaxLengthStr: st.editorHistMaxLengthStr
        };
}

function setAsrtsToSkip(st, asrtsToSkip) {
  return {
          parens: st.parens,
          parensErr: st.parensErr,
          asrtsToSkip: asrtsToSkip,
          asrtsToSkipRegex: st.asrtsToSkipRegex,
          editStmtsByLeftClick: st.editStmtsByLeftClick,
          initStmtIsGoal: st.initStmtIsGoal,
          defaultStmtLabel: st.defaultStmtLabel,
          defaultStmtType: st.defaultStmtType,
          checkSyntax: st.checkSyntax,
          stickGoalToBottom: st.stickGoalToBottom,
          typeNextId: st.typeNextId,
          typeSettings: st.typeSettings,
          webSrcNextId: st.webSrcNextId,
          webSrcSettings: st.webSrcSettings,
          longClickEnabled: st.longClickEnabled,
          longClickDelayMsStr: st.longClickDelayMsStr,
          hideContextSelector: st.hideContextSelector,
          showVisByDefault: st.showVisByDefault,
          editorHistMaxLengthStr: st.editorHistMaxLengthStr
        };
}

function updateTypeSetting(st, id, update) {
  return {
          parens: st.parens,
          parensErr: st.parensErr,
          asrtsToSkip: st.asrtsToSkip,
          asrtsToSkipRegex: st.asrtsToSkipRegex,
          editStmtsByLeftClick: st.editStmtsByLeftClick,
          initStmtIsGoal: st.initStmtIsGoal,
          defaultStmtLabel: st.defaultStmtLabel,
          defaultStmtType: st.defaultStmtType,
          checkSyntax: st.checkSyntax,
          stickGoalToBottom: st.stickGoalToBottom,
          typeNextId: st.typeNextId,
          typeSettings: st.typeSettings.map(function (ts) {
                if (ts.id === id) {
                  return Curry._1(update, ts);
                } else {
                  return ts;
                }
              }),
          webSrcNextId: st.webSrcNextId,
          webSrcSettings: st.webSrcSettings,
          longClickEnabled: st.longClickEnabled,
          longClickDelayMsStr: st.longClickDelayMsStr,
          hideContextSelector: st.hideContextSelector,
          showVisByDefault: st.showVisByDefault,
          editorHistMaxLengthStr: st.editorHistMaxLengthStr
        };
}

function addTypeSetting(st) {
  var newId = String(st.typeNextId);
  return {
          parens: st.parens,
          parensErr: st.parensErr,
          asrtsToSkip: st.asrtsToSkip,
          asrtsToSkipRegex: st.asrtsToSkipRegex,
          editStmtsByLeftClick: st.editStmtsByLeftClick,
          initStmtIsGoal: st.initStmtIsGoal,
          defaultStmtLabel: st.defaultStmtLabel,
          defaultStmtType: st.defaultStmtType,
          checkSyntax: st.checkSyntax,
          stickGoalToBottom: st.stickGoalToBottom,
          typeNextId: st.typeNextId + 1 | 0,
          typeSettings: st.typeSettings.concat([{
                  id: newId,
                  typ: "",
                  color: Caml_array.get(allColors, 0),
                  prefix: "",
                  err: undefined
                }]),
          webSrcNextId: st.webSrcNextId,
          webSrcSettings: st.webSrcSettings,
          longClickEnabled: st.longClickEnabled,
          longClickDelayMsStr: st.longClickDelayMsStr,
          hideContextSelector: st.hideContextSelector,
          showVisByDefault: st.showVisByDefault,
          editorHistMaxLengthStr: st.editorHistMaxLengthStr
        };
}

function updateWebSrcSetting(st, id, update) {
  return {
          parens: st.parens,
          parensErr: st.parensErr,
          asrtsToSkip: st.asrtsToSkip,
          asrtsToSkipRegex: st.asrtsToSkipRegex,
          editStmtsByLeftClick: st.editStmtsByLeftClick,
          initStmtIsGoal: st.initStmtIsGoal,
          defaultStmtLabel: st.defaultStmtLabel,
          defaultStmtType: st.defaultStmtType,
          checkSyntax: st.checkSyntax,
          stickGoalToBottom: st.stickGoalToBottom,
          typeNextId: st.typeNextId,
          typeSettings: st.typeSettings,
          webSrcNextId: st.webSrcNextId,
          webSrcSettings: st.webSrcSettings.map(function (s) {
                if (s.id === id) {
                  return Curry._1(update, s);
                } else {
                  return s;
                }
              }),
          longClickEnabled: st.longClickEnabled,
          longClickDelayMsStr: st.longClickDelayMsStr,
          hideContextSelector: st.hideContextSelector,
          showVisByDefault: st.showVisByDefault,
          editorHistMaxLengthStr: st.editorHistMaxLengthStr
        };
}

function MM_cmp_settings(props) {
  var onChange = props.onChange;
  var settings = props.settings;
  var ctx = props.ctx;
  var modalRef = props.modalRef;
  var match = React.useState(function () {
        return settingsToState(settings);
      });
  var setState = match[1];
  var state = match[0];
  var match$1 = React.useState(function () {
        return state;
      });
  var setPrevState = match$1[1];
  var prevState = match$1[0];
  React.useEffect((function () {
          var newState = settingsToState(settings);
          Curry._1(setState, (function (param) {
                  return newState;
                }));
          Curry._1(setPrevState, (function (param) {
                  return newState;
                }));
        }), [props.settingsVer]);
  var actParensChange = function (parens) {
    Curry._1(setState, (function (__x) {
            return updateParens(__x, parens);
          }));
  };
  var actEditStmtsByLeftClickChange = function (editStmtsByLeftClick) {
    Curry._1(setState, (function (__x) {
            return {
                    parens: __x.parens,
                    parensErr: __x.parensErr,
                    asrtsToSkip: __x.asrtsToSkip,
                    asrtsToSkipRegex: __x.asrtsToSkipRegex,
                    editStmtsByLeftClick: editStmtsByLeftClick,
                    initStmtIsGoal: __x.initStmtIsGoal,
                    defaultStmtLabel: __x.defaultStmtLabel,
                    defaultStmtType: __x.defaultStmtType,
                    checkSyntax: __x.checkSyntax,
                    stickGoalToBottom: __x.stickGoalToBottom,
                    typeNextId: __x.typeNextId,
                    typeSettings: __x.typeSettings,
                    webSrcNextId: __x.webSrcNextId,
                    webSrcSettings: __x.webSrcSettings,
                    longClickEnabled: __x.longClickEnabled,
                    longClickDelayMsStr: __x.longClickDelayMsStr,
                    hideContextSelector: __x.hideContextSelector,
                    showVisByDefault: __x.showVisByDefault,
                    editorHistMaxLengthStr: __x.editorHistMaxLengthStr
                  };
          }));
  };
  var actInitStmtIsGoalChange = function (initStmtIsGoal) {
    Curry._1(setState, (function (__x) {
            return {
                    parens: __x.parens,
                    parensErr: __x.parensErr,
                    asrtsToSkip: __x.asrtsToSkip,
                    asrtsToSkipRegex: __x.asrtsToSkipRegex,
                    editStmtsByLeftClick: __x.editStmtsByLeftClick,
                    initStmtIsGoal: initStmtIsGoal,
                    defaultStmtLabel: __x.defaultStmtLabel,
                    defaultStmtType: __x.defaultStmtType,
                    checkSyntax: __x.checkSyntax,
                    stickGoalToBottom: __x.stickGoalToBottom,
                    typeNextId: __x.typeNextId,
                    typeSettings: __x.typeSettings,
                    webSrcNextId: __x.webSrcNextId,
                    webSrcSettings: __x.webSrcSettings,
                    longClickEnabled: __x.longClickEnabled,
                    longClickDelayMsStr: __x.longClickDelayMsStr,
                    hideContextSelector: __x.hideContextSelector,
                    showVisByDefault: __x.showVisByDefault,
                    editorHistMaxLengthStr: __x.editorHistMaxLengthStr
                  };
          }));
  };
  var actDefaultStmtLabelChange = function (defaultStmtLabel) {
    Curry._1(setState, (function (__x) {
            return {
                    parens: __x.parens,
                    parensErr: __x.parensErr,
                    asrtsToSkip: __x.asrtsToSkip,
                    asrtsToSkipRegex: __x.asrtsToSkipRegex,
                    editStmtsByLeftClick: __x.editStmtsByLeftClick,
                    initStmtIsGoal: __x.initStmtIsGoal,
                    defaultStmtLabel: defaultStmtLabel,
                    defaultStmtType: __x.defaultStmtType,
                    checkSyntax: __x.checkSyntax,
                    stickGoalToBottom: __x.stickGoalToBottom,
                    typeNextId: __x.typeNextId,
                    typeSettings: __x.typeSettings,
                    webSrcNextId: __x.webSrcNextId,
                    webSrcSettings: __x.webSrcSettings,
                    longClickEnabled: __x.longClickEnabled,
                    longClickDelayMsStr: __x.longClickDelayMsStr,
                    hideContextSelector: __x.hideContextSelector,
                    showVisByDefault: __x.showVisByDefault,
                    editorHistMaxLengthStr: __x.editorHistMaxLengthStr
                  };
          }));
  };
  var actDefaultStmtTypeChange = function (defaultStmtType) {
    Curry._1(setState, (function (__x) {
            return {
                    parens: __x.parens,
                    parensErr: __x.parensErr,
                    asrtsToSkip: __x.asrtsToSkip,
                    asrtsToSkipRegex: __x.asrtsToSkipRegex,
                    editStmtsByLeftClick: __x.editStmtsByLeftClick,
                    initStmtIsGoal: __x.initStmtIsGoal,
                    defaultStmtLabel: __x.defaultStmtLabel,
                    defaultStmtType: defaultStmtType,
                    checkSyntax: __x.checkSyntax,
                    stickGoalToBottom: __x.stickGoalToBottom,
                    typeNextId: __x.typeNextId,
                    typeSettings: __x.typeSettings,
                    webSrcNextId: __x.webSrcNextId,
                    webSrcSettings: __x.webSrcSettings,
                    longClickEnabled: __x.longClickEnabled,
                    longClickDelayMsStr: __x.longClickDelayMsStr,
                    hideContextSelector: __x.hideContextSelector,
                    showVisByDefault: __x.showVisByDefault,
                    editorHistMaxLengthStr: __x.editorHistMaxLengthStr
                  };
          }));
  };
  var actLongClickDelayMsStrChange = function (longClickDelayMsStr) {
    Curry._1(setState, (function (__x) {
            return {
                    parens: __x.parens,
                    parensErr: __x.parensErr,
                    asrtsToSkip: __x.asrtsToSkip,
                    asrtsToSkipRegex: __x.asrtsToSkipRegex,
                    editStmtsByLeftClick: __x.editStmtsByLeftClick,
                    initStmtIsGoal: __x.initStmtIsGoal,
                    defaultStmtLabel: __x.defaultStmtLabel,
                    defaultStmtType: __x.defaultStmtType,
                    checkSyntax: __x.checkSyntax,
                    stickGoalToBottom: __x.stickGoalToBottom,
                    typeNextId: __x.typeNextId,
                    typeSettings: __x.typeSettings,
                    webSrcNextId: __x.webSrcNextId,
                    webSrcSettings: __x.webSrcSettings,
                    longClickEnabled: __x.longClickEnabled,
                    longClickDelayMsStr: longClickDelayMsStr,
                    hideContextSelector: __x.hideContextSelector,
                    showVisByDefault: __x.showVisByDefault,
                    editorHistMaxLengthStr: __x.editorHistMaxLengthStr
                  };
          }));
  };
  var actEditorHistMaxLengthStrChange = function (editorHistMaxLengthStr) {
    Curry._1(setState, (function (__x) {
            return {
                    parens: __x.parens,
                    parensErr: __x.parensErr,
                    asrtsToSkip: __x.asrtsToSkip,
                    asrtsToSkipRegex: __x.asrtsToSkipRegex,
                    editStmtsByLeftClick: __x.editStmtsByLeftClick,
                    initStmtIsGoal: __x.initStmtIsGoal,
                    defaultStmtLabel: __x.defaultStmtLabel,
                    defaultStmtType: __x.defaultStmtType,
                    checkSyntax: __x.checkSyntax,
                    stickGoalToBottom: __x.stickGoalToBottom,
                    typeNextId: __x.typeNextId,
                    typeSettings: __x.typeSettings,
                    webSrcNextId: __x.webSrcNextId,
                    webSrcSettings: __x.webSrcSettings,
                    longClickEnabled: __x.longClickEnabled,
                    longClickDelayMsStr: __x.longClickDelayMsStr,
                    hideContextSelector: __x.hideContextSelector,
                    showVisByDefault: __x.showVisByDefault,
                    editorHistMaxLengthStr: editorHistMaxLengthStr
                  };
          }));
  };
  var actCheckSyntaxChange = function (checkSyntax) {
    Curry._1(setState, (function (__x) {
            return {
                    parens: __x.parens,
                    parensErr: __x.parensErr,
                    asrtsToSkip: __x.asrtsToSkip,
                    asrtsToSkipRegex: __x.asrtsToSkipRegex,
                    editStmtsByLeftClick: __x.editStmtsByLeftClick,
                    initStmtIsGoal: __x.initStmtIsGoal,
                    defaultStmtLabel: __x.defaultStmtLabel,
                    defaultStmtType: __x.defaultStmtType,
                    checkSyntax: checkSyntax,
                    stickGoalToBottom: __x.stickGoalToBottom,
                    typeNextId: __x.typeNextId,
                    typeSettings: __x.typeSettings,
                    webSrcNextId: __x.webSrcNextId,
                    webSrcSettings: __x.webSrcSettings,
                    longClickEnabled: __x.longClickEnabled,
                    longClickDelayMsStr: __x.longClickDelayMsStr,
                    hideContextSelector: __x.hideContextSelector,
                    showVisByDefault: __x.showVisByDefault,
                    editorHistMaxLengthStr: __x.editorHistMaxLengthStr
                  };
          }));
  };
  var actHideContextSelectorChange = function (hideContextSelector) {
    Curry._1(setState, (function (__x) {
            return {
                    parens: __x.parens,
                    parensErr: __x.parensErr,
                    asrtsToSkip: __x.asrtsToSkip,
                    asrtsToSkipRegex: __x.asrtsToSkipRegex,
                    editStmtsByLeftClick: __x.editStmtsByLeftClick,
                    initStmtIsGoal: __x.initStmtIsGoal,
                    defaultStmtLabel: __x.defaultStmtLabel,
                    defaultStmtType: __x.defaultStmtType,
                    checkSyntax: __x.checkSyntax,
                    stickGoalToBottom: __x.stickGoalToBottom,
                    typeNextId: __x.typeNextId,
                    typeSettings: __x.typeSettings,
                    webSrcNextId: __x.webSrcNextId,
                    webSrcSettings: __x.webSrcSettings,
                    longClickEnabled: __x.longClickEnabled,
                    longClickDelayMsStr: __x.longClickDelayMsStr,
                    hideContextSelector: hideContextSelector,
                    showVisByDefault: __x.showVisByDefault,
                    editorHistMaxLengthStr: __x.editorHistMaxLengthStr
                  };
          }));
  };
  var actShowVisByDefaultChange = function (showVisByDefault) {
    Curry._1(setState, (function (__x) {
            return {
                    parens: __x.parens,
                    parensErr: __x.parensErr,
                    asrtsToSkip: __x.asrtsToSkip,
                    asrtsToSkipRegex: __x.asrtsToSkipRegex,
                    editStmtsByLeftClick: __x.editStmtsByLeftClick,
                    initStmtIsGoal: __x.initStmtIsGoal,
                    defaultStmtLabel: __x.defaultStmtLabel,
                    defaultStmtType: __x.defaultStmtType,
                    checkSyntax: __x.checkSyntax,
                    stickGoalToBottom: __x.stickGoalToBottom,
                    typeNextId: __x.typeNextId,
                    typeSettings: __x.typeSettings,
                    webSrcNextId: __x.webSrcNextId,
                    webSrcSettings: __x.webSrcSettings,
                    longClickEnabled: __x.longClickEnabled,
                    longClickDelayMsStr: __x.longClickDelayMsStr,
                    hideContextSelector: __x.hideContextSelector,
                    showVisByDefault: showVisByDefault,
                    editorHistMaxLengthStr: __x.editorHistMaxLengthStr
                  };
          }));
  };
  var actStickGoalToBottomChange = function (stickGoalToBottom) {
    Curry._1(setState, (function (__x) {
            return {
                    parens: __x.parens,
                    parensErr: __x.parensErr,
                    asrtsToSkip: __x.asrtsToSkip,
                    asrtsToSkipRegex: __x.asrtsToSkipRegex,
                    editStmtsByLeftClick: __x.editStmtsByLeftClick,
                    initStmtIsGoal: __x.initStmtIsGoal,
                    defaultStmtLabel: __x.defaultStmtLabel,
                    defaultStmtType: __x.defaultStmtType,
                    checkSyntax: __x.checkSyntax,
                    stickGoalToBottom: stickGoalToBottom,
                    typeNextId: __x.typeNextId,
                    typeSettings: __x.typeSettings,
                    webSrcNextId: __x.webSrcNextId,
                    webSrcSettings: __x.webSrcSettings,
                    longClickEnabled: __x.longClickEnabled,
                    longClickDelayMsStr: __x.longClickDelayMsStr,
                    hideContextSelector: __x.hideContextSelector,
                    showVisByDefault: __x.showVisByDefault,
                    editorHistMaxLengthStr: __x.editorHistMaxLengthStr
                  };
          }));
  };
  var actLongClickEnabledChange = function (longClickEnabled) {
    Curry._1(setState, (function (__x) {
            return {
                    parens: __x.parens,
                    parensErr: __x.parensErr,
                    asrtsToSkip: __x.asrtsToSkip,
                    asrtsToSkipRegex: __x.asrtsToSkipRegex,
                    editStmtsByLeftClick: __x.editStmtsByLeftClick,
                    initStmtIsGoal: __x.initStmtIsGoal,
                    defaultStmtLabel: __x.defaultStmtLabel,
                    defaultStmtType: __x.defaultStmtType,
                    checkSyntax: __x.checkSyntax,
                    stickGoalToBottom: __x.stickGoalToBottom,
                    typeNextId: __x.typeNextId,
                    typeSettings: __x.typeSettings,
                    webSrcNextId: __x.webSrcNextId,
                    webSrcSettings: __x.webSrcSettings,
                    longClickEnabled: longClickEnabled,
                    longClickDelayMsStr: __x.longClickDelayMsStr,
                    hideContextSelector: __x.hideContextSelector,
                    showVisByDefault: __x.showVisByDefault,
                    editorHistMaxLengthStr: __x.editorHistMaxLengthStr
                  };
          }));
  };
  var actTypeSettingAdd = function (param) {
    Curry._1(setState, addTypeSetting);
  };
  var actTypeSettingDelete = function (id) {
    Curry._1(setState, (function (__x) {
            return {
                    parens: __x.parens,
                    parensErr: __x.parensErr,
                    asrtsToSkip: __x.asrtsToSkip,
                    asrtsToSkipRegex: __x.asrtsToSkipRegex,
                    editStmtsByLeftClick: __x.editStmtsByLeftClick,
                    initStmtIsGoal: __x.initStmtIsGoal,
                    defaultStmtLabel: __x.defaultStmtLabel,
                    defaultStmtType: __x.defaultStmtType,
                    checkSyntax: __x.checkSyntax,
                    stickGoalToBottom: __x.stickGoalToBottom,
                    typeNextId: __x.typeNextId,
                    typeSettings: __x.typeSettings.filter(function (ts) {
                          return ts.id !== id;
                        }),
                    webSrcNextId: __x.webSrcNextId,
                    webSrcSettings: __x.webSrcSettings,
                    longClickEnabled: __x.longClickEnabled,
                    longClickDelayMsStr: __x.longClickDelayMsStr,
                    hideContextSelector: __x.hideContextSelector,
                    showVisByDefault: __x.showVisByDefault,
                    editorHistMaxLengthStr: __x.editorHistMaxLengthStr
                  };
          }));
  };
  var actTypeChange = function (id, typ) {
    Curry._1(setState, (function (__x) {
            return updateTypeSetting(__x, id, (function (ts) {
                          return {
                                  id: ts.id,
                                  typ: typ,
                                  color: ts.color,
                                  prefix: ts.prefix,
                                  err: undefined
                                };
                        }));
          }));
  };
  var actColorChange = function (id, color) {
    Curry._1(setState, (function (__x) {
            return updateTypeSetting(__x, id, (function (ts) {
                          return {
                                  id: ts.id,
                                  typ: ts.typ,
                                  color: color,
                                  prefix: ts.prefix,
                                  err: undefined
                                };
                        }));
          }));
  };
  var actPrefixChange = function (id, prefix) {
    Curry._1(setState, (function (__x) {
            return updateTypeSetting(__x, id, (function (ts) {
                          return {
                                  id: ts.id,
                                  typ: ts.typ,
                                  color: ts.color,
                                  prefix: prefix,
                                  err: undefined
                                };
                        }));
          }));
  };
  var actWebSrcSettingAdd = function (param) {
    Curry._1(setState, addWebSrcSetting);
  };
  var actWebSrcSettingDelete = function (id) {
    Curry._1(setState, (function (__x) {
            return {
                    parens: __x.parens,
                    parensErr: __x.parensErr,
                    asrtsToSkip: __x.asrtsToSkip,
                    asrtsToSkipRegex: __x.asrtsToSkipRegex,
                    editStmtsByLeftClick: __x.editStmtsByLeftClick,
                    initStmtIsGoal: __x.initStmtIsGoal,
                    defaultStmtLabel: __x.defaultStmtLabel,
                    defaultStmtType: __x.defaultStmtType,
                    checkSyntax: __x.checkSyntax,
                    stickGoalToBottom: __x.stickGoalToBottom,
                    typeNextId: __x.typeNextId,
                    typeSettings: __x.typeSettings,
                    webSrcNextId: __x.webSrcNextId,
                    webSrcSettings: __x.webSrcSettings.filter(function (s) {
                          return s.id !== id;
                        }),
                    longClickEnabled: __x.longClickEnabled,
                    longClickDelayMsStr: __x.longClickDelayMsStr,
                    hideContextSelector: __x.hideContextSelector,
                    showVisByDefault: __x.showVisByDefault,
                    editorHistMaxLengthStr: __x.editorHistMaxLengthStr
                  };
          }));
  };
  var actAliasChange = function (id, alias) {
    Curry._1(setState, (function (__x) {
            return updateWebSrcSetting(__x, id, (function (s) {
                          return {
                                  id: s.id,
                                  alias: alias,
                                  url: s.url,
                                  trusted: s.trusted,
                                  err: undefined
                                };
                        }));
          }));
  };
  var actUrlChange = function (id, url) {
    Curry._1(setState, (function (__x) {
            return updateWebSrcSetting(__x, id, (function (s) {
                          return {
                                  id: s.id,
                                  alias: s.alias,
                                  url: url,
                                  trusted: s.trusted,
                                  err: undefined
                                };
                        }));
          }));
  };
  var actTrustedChange = function (id, trusted) {
    Curry._1(setState, (function (__x) {
            return updateWebSrcSetting(__x, id, (function (s) {
                          return {
                                  id: s.id,
                                  alias: s.alias,
                                  url: s.url,
                                  trusted: trusted,
                                  err: undefined
                                };
                        }));
          }));
  };
  var actRestoreDefaultTypeSettings = function (param) {
    Curry._1(setState, (function (state) {
            var defaultSettings = createDefaultSettings(undefined);
            return defaultSettings.typeSettings.reduce((function (state, $$default) {
                          var typ = $$default.typ;
                          var color = $$default.color;
                          var prefix = $$default.prefix;
                          var state$1;
                          if (Belt_Option.isSome(Caml_option.undefined_to_opt(state.typeSettings.find(function (ts) {
                                          return ts.typ === typ;
                                        })))) {
                            state$1 = state;
                          } else {
                            var newId = String(state.typeNextId);
                            var state$2 = addTypeSetting(state);
                            state$1 = {
                              parens: state$2.parens,
                              parensErr: state$2.parensErr,
                              asrtsToSkip: state$2.asrtsToSkip,
                              asrtsToSkipRegex: state$2.asrtsToSkipRegex,
                              editStmtsByLeftClick: state$2.editStmtsByLeftClick,
                              initStmtIsGoal: state$2.initStmtIsGoal,
                              defaultStmtLabel: state$2.defaultStmtLabel,
                              defaultStmtType: state$2.defaultStmtType,
                              checkSyntax: state$2.checkSyntax,
                              stickGoalToBottom: state$2.stickGoalToBottom,
                              typeNextId: state$2.typeNextId,
                              typeSettings: state$2.typeSettings.map(function (ts) {
                                    if (ts.id === newId) {
                                      return {
                                              id: ts.id,
                                              typ: typ,
                                              color: ts.color,
                                              prefix: ts.prefix,
                                              err: ts.err
                                            };
                                    } else {
                                      return ts;
                                    }
                                  }),
                              webSrcNextId: state$2.webSrcNextId,
                              webSrcSettings: state$2.webSrcSettings,
                              longClickEnabled: state$2.longClickEnabled,
                              longClickDelayMsStr: state$2.longClickDelayMsStr,
                              hideContextSelector: state$2.hideContextSelector,
                              showVisByDefault: state$2.showVisByDefault,
                              editorHistMaxLengthStr: state$2.editorHistMaxLengthStr
                            };
                          }
                          return {
                                  parens: state$1.parens,
                                  parensErr: state$1.parensErr,
                                  asrtsToSkip: state$1.asrtsToSkip,
                                  asrtsToSkipRegex: state$1.asrtsToSkipRegex,
                                  editStmtsByLeftClick: state$1.editStmtsByLeftClick,
                                  initStmtIsGoal: state$1.initStmtIsGoal,
                                  defaultStmtLabel: state$1.defaultStmtLabel,
                                  defaultStmtType: state$1.defaultStmtType,
                                  checkSyntax: state$1.checkSyntax,
                                  stickGoalToBottom: state$1.stickGoalToBottom,
                                  typeNextId: state$1.typeNextId,
                                  typeSettings: state$1.typeSettings.map(function (ts) {
                                        if (ts.typ === typ) {
                                          return {
                                                  id: ts.id,
                                                  typ: ts.typ,
                                                  color: color,
                                                  prefix: prefix,
                                                  err: ts.err
                                                };
                                        } else {
                                          return ts;
                                        }
                                      }),
                                  webSrcNextId: state$1.webSrcNextId,
                                  webSrcSettings: state$1.webSrcSettings,
                                  longClickEnabled: state$1.longClickEnabled,
                                  longClickDelayMsStr: state$1.longClickDelayMsStr,
                                  hideContextSelector: state$1.hideContextSelector,
                                  showVisByDefault: state$1.showVisByDefault,
                                  editorHistMaxLengthStr: state$1.editorHistMaxLengthStr
                                };
                        }), state);
          }));
  };
  var makeActTerminate = function (modalId) {
    return Belt_Option.map(modalId, (function (modalId, param) {
                  MM_wrk_client.terminateWorker(undefined);
                  Expln_React_Modal.closeModal(modalRef, modalId);
                }));
  };
  var rndFindParensProgress = function (pct, modalIdOpt) {
    return MM_react_common.rndProgress("Searching parentheses", pct, makeActTerminate(modalIdOpt), undefined);
  };
  var rndParens = function (param) {
    var elems = [];
    elems.push(JsxPPXReactSupport.createElementVariadicWithKey("parens-text-field", Expln_React_Row.make, {
              alignItems: "center",
              children: Caml_option.some(null)
            }, [
              React.createElement(TextField, {
                    value: state.parens,
                    label: "Parentheses",
                    size: "small",
                    style: {
                      width: "400px"
                    },
                    onChange: (function (param) {
                        return Expln_React_common.evt2str(actParensChange, param);
                      }),
                    title: "Parentheses are used to speed up finding of substitutions",
                    error: Belt_Option.isSome(state.parensErr)
                  }),
              React.createElement("span", {
                    title: "Determine parentheses from the loaded MM file"
                  }, React.createElement(IconButton, {
                        onClick: (function (param) {
                            Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                        return rndFindParensProgress(0, undefined);
                                      })), (function (modalId) {
                                    Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                            return rndFindParensProgress(0, Caml_option.some(modalId));
                                          }));
                                    MM_wrk_FindParens.beginFindParens(ctx, (function (pct) {
                                            Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                                    return rndFindParensProgress(pct, Caml_option.some(modalId));
                                                  }));
                                          }), (function (parens) {
                                            Curry._1(setState, (function (__x) {
                                                    return updateParens(__x, parens);
                                                  }));
                                            Expln_React_Modal.closeModal(modalRef, modalId);
                                          }));
                                  }));
                          }),
                        children: Caml_option.some(React.createElement(Sync, {}))
                      }))
            ]));
    var msg = state.parensErr;
    if (msg !== undefined) {
      elems.push(React.createElement("pre", {
                key: "parens-error",
                style: {
                  color: "red"
                }
              }, msg));
    }
    return elems;
  };
  var rndAsrtsToSkip = function (param) {
    var asrtsSelected = String(state.asrtsToSkip.length);
    return React.createElement(Expln_React_Row.make, {
                children: Caml_option.some(null)
              }, React.createElement("span", undefined, "Assertions to skip: " + asrtsSelected + " assertions selected."), React.createElement("span", {
                    style: {
                      color: "blue",
                      cursor: "pointer"
                    },
                    onClick: (function (param) {
                        Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                    return null;
                                  })), (function (modalId) {
                                Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                        return React.createElement(Paper, {
                                                    style: {
                                                      padding: "10px"
                                                    },
                                                    children: Caml_option.some(React.createElement(MM_cmp_asrts_to_skip.make, {
                                                              initText: state.asrtsToSkip.join("\n"),
                                                              initRegex: state.asrtsToSkipRegex,
                                                              onSave: (function (res) {
                                                                  Expln_React_Modal.closeModal(modalRef, modalId);
                                                                  Curry._1(setState, (function (st) {
                                                                          var st$1 = setAsrtsToSkip(st, res.asrtsToSkip);
                                                                          var asrtsToSkipRegex = res.regex;
                                                                          return {
                                                                                  parens: st$1.parens,
                                                                                  parensErr: st$1.parensErr,
                                                                                  asrtsToSkip: st$1.asrtsToSkip,
                                                                                  asrtsToSkipRegex: asrtsToSkipRegex,
                                                                                  editStmtsByLeftClick: st$1.editStmtsByLeftClick,
                                                                                  initStmtIsGoal: st$1.initStmtIsGoal,
                                                                                  defaultStmtLabel: st$1.defaultStmtLabel,
                                                                                  defaultStmtType: st$1.defaultStmtType,
                                                                                  checkSyntax: st$1.checkSyntax,
                                                                                  stickGoalToBottom: st$1.stickGoalToBottom,
                                                                                  typeNextId: st$1.typeNextId,
                                                                                  typeSettings: st$1.typeSettings,
                                                                                  webSrcNextId: st$1.webSrcNextId,
                                                                                  webSrcSettings: st$1.webSrcSettings,
                                                                                  longClickEnabled: st$1.longClickEnabled,
                                                                                  longClickDelayMsStr: st$1.longClickDelayMsStr,
                                                                                  hideContextSelector: st$1.hideContextSelector,
                                                                                  showVisByDefault: st$1.showVisByDefault,
                                                                                  editorHistMaxLengthStr: st$1.editorHistMaxLengthStr
                                                                                };
                                                                        }));
                                                                }),
                                                              onCancel: (function (param) {
                                                                  Expln_React_Modal.closeModal(modalRef, modalId);
                                                                })
                                                            }))
                                                  });
                                      }));
                              }));
                      })
                  }, "edit"));
  };
  var rndLongClickSettings = function (param) {
    return React.createElement(Expln_React_Row.make, {
                children: Caml_option.some(null)
              }, React.createElement(FormControlLabel, {
                    control: React.createElement(Checkbox, {
                          checked: state.longClickEnabled,
                          onChange: (function (param) {
                              return Expln_React_common.evt2bool(actLongClickEnabledChange, param);
                            })
                        }),
                    label: "Enable long-click"
                  }), React.createElement(TextField, {
                    value: state.longClickDelayMsStr,
                    label: "Long click delay, ms",
                    size: "small",
                    style: {
                      width: "150px"
                    },
                    onChange: (function (param) {
                        return Expln_React_common.evt2str(actLongClickDelayMsStrChange, param);
                      }),
                    disabled: !state.longClickEnabled,
                    title: "How many milliseconds to wait for a click to become \"long\""
                  }));
  };
  var rndApplyChangesBtn = function (param) {
    var disabled = !isValid(state) || eqState(prevState, state);
    return React.createElement(Expln_React_Row.make, {
                spacing: 3,
                children: Caml_option.some(null)
              }, React.createElement(Button, {
                    onClick: (function (param) {
                        var st = validateAndCorrectState(state);
                        Curry._1(setState, (function (param) {
                                return st;
                              }));
                        if (isValid(st)) {
                          Curry._1(setPrevState, (function (param) {
                                  return st;
                                }));
                          return Curry._1(onChange, stateToSettings(st));
                        }
                        
                      }),
                    variant: "contained",
                    disabled: disabled,
                    children: "Apply changes"
                  }), React.createElement(Button, {
                    onClick: (function (param) {
                        Curry._1(setState, (function (param) {
                                return prevState;
                              }));
                      }),
                    disabled: disabled,
                    children: "Discard changes"
                  }));
  };
  return React.createElement(Expln_React_Column.make, {
              spacing: 2,
              style: {
                margin: "30px"
              },
              children: Caml_option.some(null)
            }, rndApplyChangesBtn(undefined), React.createElement(Divider, {}), rndParens(undefined), React.createElement(FormControlLabel, {
                  control: React.createElement(Checkbox, {
                        checked: state.checkSyntax,
                        onChange: (function (param) {
                            return Expln_React_common.evt2bool(actCheckSyntaxChange, param);
                          })
                      }),
                  label: "Check syntax"
                }), rndAsrtsToSkip(undefined), React.createElement(FormControlLabel, {
                  control: React.createElement(Checkbox, {
                        checked: state.initStmtIsGoal,
                        onChange: (function (param) {
                            return Expln_React_common.evt2bool(actInitStmtIsGoalChange, param);
                          })
                      }),
                  label: "Mark the first provable step as a goal"
                }), React.createElement(FormControlLabel, {
                  control: React.createElement(Checkbox, {
                        checked: state.stickGoalToBottom,
                        onChange: (function (param) {
                            return Expln_React_common.evt2bool(actStickGoalToBottomChange, param);
                          })
                      }),
                  label: "Stick the goal step to the bottom"
                }), React.createElement(TextField, {
                  value: state.defaultStmtLabel,
                  label: "Initial step label",
                  size: "small",
                  style: {
                    width: "200px"
                  },
                  onChange: (function (param) {
                      return Expln_React_common.evt2str(actDefaultStmtLabelChange, param);
                    }),
                  title: "This text is used as a label for the first provable step. If empty - a label will be generated automatically."
                }), React.createElement(TextField, {
                  value: state.defaultStmtType,
                  label: "Default statement type",
                  size: "small",
                  style: {
                    width: "200px"
                  },
                  onChange: (function (param) {
                      return Expln_React_common.evt2str(actDefaultStmtTypeChange, param);
                    }),
                  title: "This text is used as the initial statement type for new statements"
                }), React.createElement(MM_cmp_edit_stmts_setting.make, {
                  editStmtsByLeftClick: state.editStmtsByLeftClick,
                  longClickEnabled: state.longClickEnabled,
                  onChange: actEditStmtsByLeftClickChange
                }), rndLongClickSettings(undefined), React.createElement(FormControlLabel, {
                  control: React.createElement(Checkbox, {
                        checked: state.hideContextSelector,
                        onChange: (function (param) {
                            return Expln_React_common.evt2bool(actHideContextSelectorChange, param);
                          })
                      }),
                  label: "Hide context header"
                }), React.createElement(FormControlLabel, {
                  control: React.createElement(Checkbox, {
                        checked: state.showVisByDefault,
                        onChange: (function (param) {
                            return Expln_React_common.evt2bool(actShowVisByDefaultChange, param);
                          })
                      }),
                  label: "Show visualizations by default"
                }), React.createElement(TextField, {
                  value: state.editorHistMaxLengthStr,
                  label: "Max length of editor history",
                  size: "small",
                  style: {
                    width: "200px"
                  },
                  onChange: (function (param) {
                      return Expln_React_common.evt2str(actEditorHistMaxLengthStrChange, param);
                    }),
                  title: "How many previous editor states to store."
                }), React.createElement(Divider, {}), React.createElement(MM_cmp_type_settings.make, {
                  typeSettings: state.typeSettings,
                  availableColors: allColors,
                  onAdd: actTypeSettingAdd,
                  onTypeChange: actTypeChange,
                  onColorChange: actColorChange,
                  onPrefixChange: actPrefixChange,
                  onDelete: actTypeSettingDelete,
                  onRestoreDefaults: actRestoreDefaultTypeSettings
                }), React.createElement(Divider, {}), React.createElement(MM_cmp_web_src_settings.make, {
                  webSrcSettings: state.webSrcSettings,
                  onAdd: actWebSrcSettingAdd,
                  onAliasChange: actAliasChange,
                  onUrlChange: actUrlChange,
                  onTrustedChange: actTrustedChange,
                  onDelete: actWebSrcSettingDelete,
                  defaultIds: defaultAliases.map(function (defaultAlias) {
                            return Caml_option.undefined_to_opt(state.webSrcSettings.find(function (webSrc) {
                                            return webSrc.alias === defaultAlias;
                                          }));
                          }).filter(Belt_Option.isSome).map(function (webSrcOpt) {
                        return Belt_Option.getExn(webSrcOpt).id;
                      })
                }), React.createElement(Divider, {}), rndApplyChangesBtn(undefined));
}

var make = MM_cmp_settings;

exports.settingsReadFromLocStor = settingsReadFromLocStor;
exports.settingsSaveToLocStor = settingsSaveToLocStor;
exports.make = make;
/* react Not a pure module */
